import { Injectable } from '@angular/core';
import { AbstractEntityStore } from '@pf/shared-services';
import { PFWmsEntities } from '@pf/shared-common';
import { ReceiptLineRead } from '../../entities/receipt-line.dto';

@Injectable()
export class ReceiptLineStore extends AbstractEntityStore<ReceiptLineRead> {
    constructor() {
        super(PFWmsEntities.ReceiptLine);
    }
}
